import { createSelector } from 'reselect';
import {
  DATA_CONFIG,
  CONFIG_BASE_URL,
  DATA_SEARCH,
} from '../actions/config.actions'
import { List } from 'immutable';

export const getSearchTerm = (state) => state.get(DATA_SEARCH, '');

const getSearchTermForFilter = createSelector(
  getSearchTerm,
  (search) => search.toLowerCase()
)

export const getConfig = (state) => state.get(DATA_CONFIG, new List());

export const getFormatedConfig = createSelector(
  getConfig,
  (config) => config.map((c) => c.set('content', c.get('content').map((i) => i.set('image', CONFIG_BASE_URL + i.get('image')))))
)

export const getFilteredConfig = createSelector(
  getFormatedConfig,
  getSearchTermForFilter,
  (config, searchTerm) => !searchTerm ? config : config.reduce((r, v) => {
    const content = v.get('content', new List()).filter((c) => c.get('name', '').toLowerCase().search(searchTerm) > -1);
    if (!content.isEmpty()) {
      r = r.push(v.set('content', content))
    }
    return r;
  }, new List())
)

export const getNav = createSelector(
  getConfig,
  (config) => ({
    top: config.map((x) => ({
      name: x.get('name', 'Undefined'),
      url: x.get('path', '/'),
      icon: x.get('icon', ''),
    })).toArray(),
    bottom: []
  })
);

export const getDefaultPath = createSelector(
  getConfig,
  (config) => config.first(new Map()).get('path', '/') || '/'
)

const configToRoutes = (config) => config.map((x) => ({
  name: x.get('name', 'Undefined'),
  path: x.get('path', '/'),
})).toArray()

export const getRoutes = createSelector(
  getConfig,
  (config) => configToRoutes(config)
)

export const getFilteredRoutes = createSelector(
  getFilteredConfig,
  (config) => configToRoutes(config)
)

const configToPageContent = (config) => config.reduce((r, c) =>
r.set(
  c.get('path', '/'),
  c.get('content', new List()).map((x) => x.set('image', CONFIG_BASE_URL + x.get('image')))
)
, new Map());

export const getPagesContent = createSelector(
  getConfig,
  (config) => configToPageContent(config)
)

export const getFilteredPagesContent = createSelector(
  getFilteredConfig,
  (config) => configToPageContent(config)
)
